<header class="sticky-top bg-white border-bottom">
  <ng-content select="[top]" />
  <nav class="navigation" aria-label="Hoofd navigatie">
    <div [ngClass]="enableEssentRebranding ? 'container-md' : 'container'">
      <div class="d-flex justify-content-between">
        <div class="navigation__left">
          <ng-content select="[left]" />
        </div>
        <div class="navigation__center">
          <ng-content select="[center]" />
        </div>
        <div class="navigation__right">
          <ng-content select="[right]" />
        </div>
      </div>
    </div>
  </nav>
  <ng-content select="[bottom]" />
</header>

<!-- here for debugging purposes, this will show all elements without a "position" under the navbar -->
<ng-content />
